import { shallowMount } from "@vue/test-utils";
import EmploymentSituation from "@/components/core/composite/combos/EmploymentSituation";

describe("EmploymentSituation component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(EmploymentSituation);
  });

  it("Renders del component EmploymentSituation", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
